// Character to join category name and form the "productType"
export const CATEGORY_SEPARATOR = '/';